// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Context from "../../provider/Context.bs.js";
import * as Atom_Box from "../atom/Atom_Box.bs.js";
import * as Atom_Cta from "../atom/Atom_Cta.bs.js";
import * as Atom_Cell from "../atom/Atom_Cell.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Util_Array from "../../util/Util_Array.bs.js";
import * as Atom_Column from "../atom/Atom_Column.bs.js";
import * as Atom_Cta_Ds from "../atom/Atom_Cta_Ds.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Particle_zIndex from "../particle/Particle_zIndex.bs.js";
import * as Particle_Screen_Ds from "../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../particle/Particle_Spacer_Ds.bs.js";
import * as Particle_Accessibility from "../particle/Particle_Accessibility.bs.js";
import * as Particle_Background_Ds from "../particle/Particle_Background_Ds.bs.js";
import * as Particle_Screen_Constants from "../particle/Particle_Screen_Constants.bs.js";

var containerBlockspace = Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeAll("S")), Caml_option.some(Particle_Spacer_Ds.makeAll("M")), undefined, Particle_Spacer_Ds.makeAll("XS")));

function playerCentered(onClose) {
  return {
          contentPosition: /* Center */1,
          closeButton: onClose,
          background: Particle_Background_Ds.modalOverlay,
          blockSpace: containerBlockspace
        };
}

function playerLeft(onClose) {
  return {
          contentPosition: /* Left */0,
          closeButton: onClose,
          background: Particle_Background_Ds.modalOverlay,
          blockSpace: containerBlockspace
        };
}

var $$default = {
  contentPosition: /* Center */1,
  closeButton: undefined,
  background: Particle_Background_Ds.modalOverlay,
  blockSpace: containerBlockspace
};

var eventZoneButton = {
  contentPosition: /* Center */1,
  closeButton: undefined,
  background: Particle_Background_Ds.eventZoneOverlay,
  blockSpace: undefined
};

var eventZonePlayer = {
  contentPosition: /* Center */1,
  closeButton: undefined,
  background: Particle_Background_Ds.transparent,
  blockSpace: undefined
};

var profileForm = {
  contentPosition: /* Center */1,
  closeButton: undefined,
  background: Particle_Background_Ds.transparent,
  blockSpace: undefined
};

var Organism_Overlay_Ds = {
  playerCentered: playerCentered,
  playerLeft: playerLeft,
  $$default: $$default,
  eventZoneButton: eventZoneButton,
  eventZonePlayer: eventZonePlayer,
  profileForm: profileForm
};

var closeButtonRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [
      CssJs.position("absolute"),
      CssJs.top("zero"),
      CssJs.right("zero")
    ]);

var baseRules = [
  CssJs.top("zero"),
  CssJs.left("zero"),
  CssJs.bottom("zero"),
  CssJs.right("zero")
];

function getContainerRules(zIndex, position) {
  return Particle_Screen_Ds.map((function (p) {
                if (zIndex !== undefined) {
                  return Belt_Array.concat([
                              Particle_zIndex.Particle_zIndex_Css.toCss(zIndex),
                              CssJs.position(p)
                            ], baseRules);
                } else {
                  return Belt_Array.concat([CssJs.position(p)], baseRules);
                }
              }), position);
}

var closeButtonWidth = Particle_Screen_Ds.catOption(0, Atom_Cta_Ds.getPredefinedWidth(Atom_Cta_Ds.make({
              TAG: /* Player */15,
              _0: /* CloseOverlay */2
            })));

var contentLeftRules = Particle_Screen_Ds.map((function (width) {
        return [CssJs.paddingRight(CssJs.px(width))];
      }), closeButtonWidth);

var contentCenterRules = Particle_Screen_Ds.map((function (width) {
        return [
                CssJs.paddingLeft(CssJs.px(width)),
                CssJs.paddingRight(CssJs.px(width))
              ];
      }), closeButtonWidth);

function Organism_Overlay$Internal(Props) {
  var children = Props.children;
  var status = Props.status;
  var zIndex = Props.zIndex;
  var style = Props.style;
  var closeButtonAriaLabel = Props.closeButtonAriaLabel;
  var positionOpt = Props.position;
  var rules = Props.rules;
  var position = positionOpt !== undefined ? Caml_option.valFromOption(positionOpt) : Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "absolute");
  var match = Context.I18n.getState(undefined);
  var match$1 = match.labels.accessibility;
  var closeAriaLabel = Belt_Option.getWithDefault(closeButtonAriaLabel, match$1.close);
  var accessibility = Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, closeAriaLabel, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  var containerRules = getContainerRules(zIndex, position);
  var rules$1 = Particle_Screen_Ds.$$Array.concat(Belt_Option.getWithDefault(rules, Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [])), containerRules);
  if (!status) {
    return null;
  }
  var match$2;
  if (style.contentPosition) {
    var onClose = style.closeButton;
    match$2 = onClose !== undefined ? [
        Caml_option.some(contentCenterRules),
        Caml_option.some(Particle_Screen_Constants.justifyContentCenter),
        Caml_option.some(Particle_Screen_Constants.alignItemsCenter),
        React.createElement(Atom_Box.make, {
              children: React.createElement(Atom_Cta.Button.make, {
                    accessibility: accessibility,
                    onClick: (function (param) {
                        Curry._1(onClose, undefined);
                      }),
                    style: {
                      TAG: /* Player */15,
                      _0: /* CloseOverlay */2
                    }
                  }),
              rules: closeButtonRules
            })
      ] : [
        undefined,
        Caml_option.some(Particle_Screen_Constants.justifyContentCenter),
        Caml_option.some(Particle_Screen_Constants.alignItemsCenter),
        null
      ];
  } else {
    var onClose$1 = style.closeButton;
    match$2 = onClose$1 !== undefined ? [
        Caml_option.some(contentLeftRules),
        undefined,
        undefined,
        React.createElement(Atom_Box.make, {
              children: React.createElement(Atom_Cta.Button.make, {
                    accessibility: accessibility,
                    onClick: (function (param) {
                        Curry._1(onClose$1, undefined);
                      }),
                    style: {
                      TAG: /* Player */15,
                      _0: /* CloseOverlay */2
                    }
                  }),
              rules: closeButtonRules
            })
      ] : [
        undefined,
        undefined,
        undefined,
        null
      ];
  }
  var tmp = {
    width: Particle_Screen_Constants.oneHundredPctWidth,
    height: Particle_Screen_Constants.oneHundredPctHeight,
    children: null,
    identifier: "closeable-content"
  };
  var tmp$1 = match$2[1];
  if (tmp$1 !== undefined) {
    tmp.justifyContent = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = match$2[2];
  if (tmp$2 !== undefined) {
    tmp.alignItems = Caml_option.valFromOption(tmp$2);
  }
  var tmp$3 = match$2[0];
  if (tmp$3 !== undefined) {
    tmp.rules = Caml_option.valFromOption(tmp$3);
  }
  var tmp$4 = {
    background: style.background,
    children: React.createElement(Atom_Cell.make, tmp, match$2[3], children),
    identifier: "closeable-container",
    rules: rules$1
  };
  if (style.blockSpace !== undefined) {
    tmp$4.blockSpace = Caml_option.valFromOption(style.blockSpace);
  }
  return React.createElement(Atom_Column.make, tmp$4);
}

var Internal = {
  make: Organism_Overlay$Internal
};

function Organism_Overlay(Props) {
  var children = Props.children;
  var isOpen = Props.isOpen;
  var zIndex = Props.zIndex;
  var styleOpt = Props.style;
  var style = styleOpt !== undefined ? styleOpt : $$default;
  var tmp = {
    children: children,
    status: isOpen ? /* Show */1 : /* Hide */0,
    style: style
  };
  if (zIndex !== undefined) {
    tmp.zIndex = Caml_option.valFromOption(zIndex);
  }
  return React.createElement(Organism_Overlay$Internal, tmp);
}

var position = Particle_Screen_Ds.make(undefined, undefined, "absolute", undefined, undefined, "fixed");

function Organism_Overlay$Player(Props) {
  var alignmentOpt = Props.alignment;
  var children = Props.children;
  var onClose = Props.onClose;
  var isOpen = Props.isOpen;
  var zIndex = Props.zIndex;
  var closeButtonAriaLabel = Props.closeButtonAriaLabel;
  var alignment = alignmentOpt !== undefined ? alignmentOpt : /* Left */1;
  var style = alignment ? playerLeft(onClose) : playerCentered(onClose);
  var rules = Belt_Option.map(zIndex, (function (zIndex) {
          return Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Util_Array.pure(CssJs.zIndex(zIndex)));
        }));
  var tmp = {
    children: children,
    status: isOpen ? /* Show */1 : /* Hide */0,
    style: style,
    position: position
  };
  if (closeButtonAriaLabel !== undefined) {
    tmp.closeButtonAriaLabel = Caml_option.valFromOption(closeButtonAriaLabel);
  }
  if (rules !== undefined) {
    tmp.rules = Caml_option.valFromOption(rules);
  }
  return React.createElement(Organism_Overlay$Internal, tmp);
}

var Player = {
  position: position,
  make: Organism_Overlay$Player
};

var make = Organism_Overlay;

export {
  containerBlockspace ,
  Organism_Overlay_Ds ,
  closeButtonRules ,
  baseRules ,
  getContainerRules ,
  closeButtonWidth ,
  contentLeftRules ,
  contentCenterRules ,
  Internal ,
  make ,
  Player ,
}
/* containerBlockspace Not a pure module */
